import { gql } from '@apollo/client'

export const FileMetadataFragment = gql`
  fragment FileMetadata on FileMetadata {
    blobName
    container
    fileName
    fileType
    fileSize
    uploadedBy
    uploadedAt
    url
  }
`
